module.exports = __webpack_public_path__ + "static/media/certificate.0f039242.jpeg";